import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";

export default function Footer() {
  return (
    <Box
      sx={{
        bgcolor: "#1565c0",
        color: "#fff",
        py: 2,
        textAlign: "center",
      }}
    >
      <Typography variant="body2">
        © {new Date().getFullYear()} Machenical Workshop. All Rights Reserved. Contact for Help 9450887365 or amit@sriyansh.com
      </Typography>
    </Box>
  );
}